
























import Vue from 'vue'
import { debounce } from 'debounce'
import Template from '@/types/Template.interface'
import templateMixin from '@/mixins/template-mixin'
import IList from '@/types/components/IList.interface'
import IListTile from '@/types/components/IListTile.interface'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import Button from '@/types/components/Button.interface'
import { TemplateFilterParams } from '@/types/FilterParams.interface'
import { TemplatesParams } from '@/types/PaginationParams.interface'
import moment from 'moment-timezone'
export default Vue.extend({
    mixins: [templateMixin],
    data() {
        return {
            filter: {
                selected: {
                    display: 'Newest to Oldest',
                    key: 'sort',
                    value: 'desc'
                },
                options: [
                    {
                        display: 'Newest to Oldest',
                        key: 'sort',
                        value: 'desc'
                    },
                    {
                        display: 'Oldest to Newest',
                        key: 'sort',
                        value: 'asc'
                    }
                ]
            },
            //  Determines if we had filtered or not
            filtered: false,
            //  The list contiang our filtered templates
            filterResults: null,
            //  Determines if we had searched or not
            searched: false,
            //  The list of templates we got from the search
            searchResults: null,
            //  Our container for our search text
            searchtext: '',
            //  Placeholder for when there are 0 templates
            templatesListPlaceholder: {
                content: 'No Templates Found',
                img: 'noMessages'
            },
            toolbar: {
                title: 'Templates',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/home',
                        tooltip: 'Back',
                        permission: 0
                    }
                ],
                right: []
            }
        }
    },
    computed: {
        //  The default params
        defaultParams(): TemplateFilterParams {
            return this.$store.getters.templatesViewDefaultParams
        },
        noTemplates() {
            //  If we don't have templates, return false
            if (!this.templates) return false

            //  Else, count how many are NOT default
            const count = this.templates.filter((x) => !x.default).length

            //  Return based on count
            return !count
        },
        search: {
            get(): string {
                return this.searchtext
            },
            set: debounce(function (val: string): void {
                //  Set the searchtext state
                this.searchtext = val
                this.templatesSearch()
            }, 750)
        },
        templates(): Template {
            //  If we have filtered, then display our filtered list
            if (this.filtered) return this.filterResults
            //  If we have searched, return the search results
            if (this.searched) return this.searchResults
            //  Else, just display our templates
            else return this.$store.getters.templatesViewTemplates
        },
        templatesIList(): IList {
            return this.$store.getters.iList('templatesViewTemplatesList')
        },
        templatesParams: {
            get(): TemplatesParams {
                return this.$store.getters.templatesViewParams
            },
            set(val: TemplatesParams): void {
                this.$store.commit('templatesViewParamsSet', val)
            }
        },
        //  Our tools displayed in our IListTools
        tools(): Button[] {
            return [
                {
                    text: 'New Template',
                    icon: 'mdi-plus',
                    color: 'primary',
                    dark: true,
                    small: true,
                    callback: () => this.popNewTemplate()
                }
            ] as Button[]
        },
        userHasPermission(): Function {
            return this.$store.getters.userHasPermission
        }
    },
    methods: {
        //  Applies our filter to our current list of templates
        applyFilter(params: TemplateFilterParams): Template[] {
            // Grab our current list of templates
            const templates = this.$store.getters.templatesViewTemplates

            //  Grab the value from our params
            const val = params.value

            //  Get our filter from the params
            const filter = {
                asc: (t1: Template, t2: Template) =>
                    moment(t1.created_at).unix() - moment(t2.created_at).unix(),
                desc: (t1: Template, t2: Template) =>
                    moment(t2.created_at).unix() - moment(t1.created_at).unix()
            }

            //  Apply our filter
            const filtered = templates.sort((x: Template, y: Template) =>
                filter[val](x, y)
            )

            //  Return our filtered list
            return filtered
        },
        editTemplate(template: Template): void {
            //  Check if the user has permission first
            const pass = this.$store.getters.userHasPermission(2)

            //  If they don't have permission, do nothing
            if (!pass) return

            //  Pop an app form with template inputs
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Edit Message Template',
                icon: 'mdi-format-size',
                color: 'primary',
                component: 'app-form',
                closeable: true,
                callback: (template) => this.templateUpdate(template),
                props: {
                    color: 'primary',
                    model: template,
                    inputs: this.$store.getters.templateInputs(template)
                }
            })
        },
        onFilterChanged(params: TemplateFilterParams): void {
            //  Check if the applied filter is the same as current filter
            const isSame = window._.isEqual(this.templatesParams, params)

            //  If the filter is the same then do nothing
            if (isSame) return

            //  Else, update our store params
            this.templatesParams = params

            //  Check if the applied filter is the default
            const isDefault = window._.isEqual(this.defaultParams, params)

            //  If it is default, then clear our filtered and list
            if (isDefault) {
                this.filtered = false
                this.filterResults = null
                return
            }

            //  We don't paginate groups so we just need to filter our actual list
            const filtered = this.applyFilter(params)

            //  Set our temporary list
            this.filterResults = filtered

            //  Set filtered to true to display our new list
            this.filtered = true
        },
        templateActions(template: Template): IListAction {
            //  If the user is an operator, they get no actions
            if (!this.userHasPermission(2)) return null

            //  Check if the template is a default template (they have a template_id taht is not 0)
            const isDefault = template.template_id !== 0

            //  If the template is a default, return nothing
            if (isDefault) return null

            //  Create our menu
            const menu: Button[] = [
                {
                    icon: 'bi-trash-fill',
                    text: 'Delete Template',
                    color: 'red',
                    callback: () => this.templateDeleteConfirm(template)
                }
            ]

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  REturn our action
            return action
        },
        templateDeleteConfirm(template: Template): void {
            //  Pop a confirm dialog
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Template?',
                text: `Are you sure you want to delete ${template.template_name}?`,
                icon: 'mdi-alert',
                callback: (result: boolean): void => this.templateDelete(result, template)
            })
        },
        async templateDelete(dialog_result: boolean, template: Template): Promise<void> {
            //  If the confirm dialog answer is NO, do nothing
            if (!dialog_result) return

            //  Else, send the delete request to the API
            const resp = await this.$store.dispatch('templatesDelete', template.id)

            //  If the request failed, do nothing
            if (!resp) return

            //  Else, Notify the user of successful delete
            this.$store.commit('appNotificationBarSet', {
                message: 'Message Template Deleted'
            })
        },
        templateIcon(): IListIcon {
            //  We have the same icon for every template
            const icon = 'mdi-format-size'

            //  Create our IListIcon
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return our created list icon
            return listIcon
        },
        templateLine3(template: Template): string {
            //  If there is no template, return
            if (!template) return

            //  Grab our template type
            const type = template.type

            //  Based on the type of template, we return a different icon
            const icon =
                {
                    message: 'bi-chat-square-dots-fill',
                    invoice: 'bi-cash'
                }[type] || 'bi-chat-square-dots-fill'

            //  Grab our name
            const name = template?.type ? template.type.toProperCase() : ''

            //  Else, return our formatted line
            return `<span class="${icon} pr-2"></span><span>${name} Template</span>`
        },
        templatesSearch(): void {
            //  If search text is null then reset
            if (!this.searchtext) {
                //  Set to false so we display regular list
                this.searched = false
                //  Set to null to get rid of our previous list of templates
                return (this.searchResults = null)
            }

            //  Else, hit up the API to search
            const text = this.searchtext

            //  Grab our templates
            const templates = this.$store.getters.templatesViewTemplates

            //  Get our search results
            const results = templates.search(text, ['message_body', 'template_name'])

            //  Set our search results
            this.searchResults = results || []

            //  Regardless of result, we searched so display the list
            this.searched = true
        },
        async templateUpdate(template: Template): Promise<void> {
            //  Send the request to the api
            const response = await this.$store.dispatch('templatesPut', template)

            //  If the response failed, do nothing
            if (!response) return

            //  Else, close the app dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Notify the user of successful update
            this.$store.commit('appNotificationBarSet', {
                message: 'Template Updated'
            })
        },
        templatesTile(): IListTile {
            return {
                actionContent: (template: Template): IListAction =>
                    this.templateActions(template),
                leftIcon: (): IListIcon => this.templateIcon(),
                line1: (template: Template): string => template.template_name,
                line2: (template: Template): string => template.message_body,
                line3: (template: Template): string => this.templateLine3(template),
                callback: (template: Template): void => this.editTemplate(template)
            }
        }
    }
})
